export const DialogKey = 'domainRoutingInfoDialog';
